import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { TextArea, Typography, Flex } from "@smartfaster-ui/components";

type ExtraWishesInputProps = {
  value: string;
  onValueChange: ({ value }: { value: string }) => void;
  placeholder?: string;
};

const SOFT_CHAR_LIMIT = 500;
export const ExtraWishesInput: FC<ExtraWishesInputProps> = ({
  value,
  onValueChange,
  placeholder,
}) => {
  const { t } = useTranslation();
  const isOverSoftLimit = value.length > SOFT_CHAR_LIMIT;

  return (
    <Flex direction="column" gap="xs">
      <TextArea
        value={value}
        onValueChange={(newValue) => onValueChange({ value: newValue })}
        placeholder={
          placeholder ?? t("interiorDesigner.extraWishes.placeholder")
        }
        rows={3}
      />
      {isOverSoftLimit && (
        <Typography variant="bodySm" color="foregroundSecondary">
          {t("interiorDesigner.extraWishes.softHint")}
        </Typography>
      )}
    </Flex>
  );
};
